import { Box, Typography, Card, Avatar, Stack, Divider } from "@mui/material";
import { fontSizes } from "../../../theme/font-sizes";

import { ScrollableOddsList } from "./scrollable-odd-list";
import { OddsCard } from "./odd-card";

export default function RacerOdds({ isMediumScreen, onClick, racerOdds }) {
  return (
    <>
      <Box sx={{ mt: 4 }}>
        <Typography
          textAlign="left"
          fontSize={isMediumScreen ? fontSizes.heading3 : fontSizes.heading2}
          fontFamily="MontserratBold"
          sx={{ color: "white", mb: 2 }}
        >
          Racer Odds
        </Typography>

        <ScrollableOddsList>
          {racerOdds.map((odd, index) => (
            <OddsCard
              onClick={() => onClick(odd)}
              isMediumScreen={isMediumScreen}
              key={index}
              {...odd}
            />
          ))}
        </ScrollableOddsList>
      </Box>
    </>
  );
}
